export type FetchPolicyDefaults = {
  timeoutMs: number
  retries: number
  retryDelayMs: number
}

export const DEFAULT_TIMEOUT_MS = 10_000
export const DEFAULT_RETRIES = 1
export const DEFAULT_RETRY_DELAY_MS = 250
export const RETRYABLE_METHODS = new Set(['GET', 'HEAD', 'OPTIONS'])
export const RETRYABLE_STATUSES = new Set([408, 429, 502, 503, 504])

export const toSafePositiveNumber = (value: number | undefined, fallback: number): number =>
  Number.isFinite(value) && (value ?? 0) > 0 ? Math.floor(value as number) : fallback

export const resolveFetchPolicyOptions = ({
  defaults,
  method,
  timeoutMs,
  retries,
  retryDelayMs,
}: {
  defaults: FetchPolicyDefaults
  method: string
  timeoutMs?: number
  retries?: number
  retryDelayMs?: number
}) => {
  const shouldRetryMethod = RETRYABLE_METHODS.has(method)

  return {
    shouldRetryMethod,
    maxRetries: shouldRetryMethod
      ? toSafePositiveNumber(retries, defaults.retries ?? DEFAULT_RETRIES)
      : 0,
    timeoutWindowMs: toSafePositiveNumber(timeoutMs, defaults.timeoutMs ?? DEFAULT_TIMEOUT_MS),
    retryBackoffMs: toSafePositiveNumber(retryDelayMs, defaults.retryDelayMs ?? DEFAULT_RETRY_DELAY_MS),
  }
}
